var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveQaBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6066 3.05176C11.0334 3.05176 11.3793 3.39768 11.3793 3.82439C11.3793 4.2511 11.0334 4.59702 10.6066 4.59702L0.77267 4.59702C0.345958 4.59702 4.00281e-05 4.2511 4.00374e-05 3.82439C4.00468e-05 3.39768 0.345958 3.05176 0.77267 3.05176L10.6066 3.05176Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51375 3.82432L7.32842 1.639C7.02669 1.33726 7.02669 0.848062 7.32842 0.546332C7.63015 0.244601 8.11936 0.244601 8.42109 0.546332L11.1527 3.27799C11.4545 3.57972 11.4545 4.06892 11.1527 4.37065L8.42109 7.10231C8.11936 7.40404 7.63015 7.40404 7.32842 7.10231C7.02669 6.80058 7.02669 6.31138 7.32842 6.00965L9.51375 3.82432Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveQaBoard);
export default __webpack_public_path__ + "static/media/move-qa-board.5739463e39f6a935c7283fff5cb5ec5a.svg";
export { ForwardRef as ReactComponent };